import { Close } from "@mui/icons-material";
import { Box, Divider, Stack, Typography } from "@mui/material";
import React from "react";

const DialogHeader = ({ title = "Modal", handleClose = () => {} }) => {
  return (
    <>
      <Stack
        direction="row"
        justifyContent="space-between"
        alignItems="center"
        sx={{ py: 2, px: 2 }}
      >
        <Typography sx={{ fontSize: "16px", fontWeight: 600 }} color="primary">
          {title}
        </Typography>
        <Box
          onClick={handleClose}
          sx={{
            cursor: "pointer",
            height: "20px",
            width: "20px",
            border: "1px solid #0C2F49",
            borderRadius: "5px",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Close sx={{ color: "#0C2F49" }} />
        </Box>
      </Stack>
      <Divider sx={{ backgroundColor: "#0C2F49", opacity: 0.5 }} />
    </>
  );
};

export default DialogHeader;
